<template>
  <div class="wb-item-outside">
    <div class="wb-item">
      <img v-if="report.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
      <div class="avatar">
        <img :src="report.avatar||defaultImg" :class="{default:!report.avatar,origin:report.avatar}" alt="">
      </div>
      <div class="content">
        <div class="top-wrap">
          <div class="title">
            {{report.title|| report.username}}
          </div>
          <div class="include-media-type">
            <img src="@assets/img/common/tips.svg" alt="change" v-if="+report.has_change === 1">
            <img src="@assets/img/common/new.svg" alt="new" v-if="+report.is_new=== 1">
            <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="+report.has_img === 1">
            <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="+report.has_video=== 1">
            <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="+report.has_sound=== 1">
          </div>
        </div>
        <!-- 微博全文显示 -->
        <div class="digest">
          {{report.content}}
        </div>
        <div class="medias">
          <div class="media" v-for="(item) in report.img_list" :key="item.id">
            <img class="img" @error="imgError($event,item,'url')" @click="playMedia(report, item)" :src="item.url">
          </div>
          <div class="media" @error="imgError($event,video,'cover')" v-for="(video) in report.video_list" @click="playMedia(report, video)"
            :style="{'background-image': `url(${video.cover || defaultImg})`}" :key="video.id">

            <!-- <img :src="video.cover || defaultImg" :key="video"> -->
            <div class='verify-success verify-item' v-if="video.has_audit&&video.has_audit==1">
              <img alt="技审通过" title="技审通过" class="verify-logo" src="@assets/img/common/verify-success-logo.svg">
            </div>

            <div class='verify-fail verify-item' v-if="video.has_audit&&video.has_audit==2">
              <img alt="技审未通过" title="技审未通过" class="verify-logo" src="@assets/img/common/verify-fail-logo.svg">
            </div>
            <img class="play" src="@assets/img/index/play.svg" alt="play">
          </div>
          <div class="media" @error="imgError($event,audio,'cover')" v-for="(audio) in report.sound_list" @click="playMedia(report, audio)"
            :style="{'background-image': `url(${audio.cover || defaultAudioImg})`}" :key="audio.id">
            <img class="play" src="@assets/img/index/play.svg" alt="play">
          </div>
        </div>
        <div class="info">
          <div class="time">
            {{report.release_time}}
          </div>
          <div class="source">
            {{report.from_platform}}
          </div>
        </div>
      </div>
      <div class="push-wrap">
        <div class="push-btn" v-if="report.has_report_role" @click="goReport(report)">
          推送报道
        </div>
        <div class="push-btn" v-if="report.has_publish" @click="pushPublish(report.id, 'material')">
          推送发布
        </div>
        <div class="push-btn" v-if="report.has_new_media" @click="pushMedia(report)">
          推新发布
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
export default {
  props: {
    report: {
      required: true,
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultImg: require("@assets/img/common/default.png"),
      defaultAudioImg: require("@assets/img/common/audioMask.png"),
    };
  },
  methods: {
    imgError(e, i, key) {
      console.log("imgerror target.parentNode", e.target.parentNode);
      // 图片加载状态
      this.$set(i, key, this.defaultImg);
      e.target.parentNode.classList.add("default");
    },
    playMedia({ sound_list, img_list, video_list }, item) {
      console.log('playMedia item', item)
      let list = [...img_list, ...video_list, ...sound_list];
      // list 有id即可
      let index = list.findIndex(e => e.id == item.id);
      this.$materialBox("", null, {
        index,
        list,
        quickEdit: this.$store.state.quickEdit,
        create: this.$store.state.create,
        canEdit: false
      });
    },
    async pushMedia(item) {
      console.log(item)
      const type = await this.$MediaPlatform('push');
      if (!type) return;
      console.log(type)
      let info = {
          platforms: type,
          submit_type: 0,
          subject_type: 0,
          subject_id: item.id
      };

      common
      .myFetch(apis.newMediaPlatformCreate, info)
      .then(r => {
          if (r) {
              console.log(r)
              common.jump(`/createMediaPublish?d=${r.report_id}`, true);
          }
      });
      // common.jump(`/createMediaPublish?d=${type}`, true);
    },
    async pushPublish(id, t) {
      // 推送发布
      const type = await this.$pageType("publish");
      if (!type) return;

      const info = {
        subject_id: id,
        subject_type: t,
        type: type
      };

      common.myFetch(apis.publish_pushPublish, info).then(r => {
        if (r) {
          const url = `/editPublish?d=${r.id}`;

          common.jump(url, true);
        }
      });
    },
    async goReport(i) {
      const type = await this.$pageType();
      if (!type) return;

      const info = {
        id: i.id,
        type: type
      };
      const newWindow = window.open();
      console.log("info", info);
      common.myFetch(apis.clue_toReport, info).then(r => {
        if (r) {
          const reportId = r.report_id;

          newWindow.location.href = `${window.location.origin
            }/creatReport?push=${i.id}&t=${type}&d=${reportId}`;

          // common.jump(`/creatReport?push=${i.id}&t=${type}&d=${reportId}`, true)
        }
      });
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/global.less";
.bg(@ratio) {
  background-color: rgba(teal, @ratio);
}
.wb-item-outside {
  padding: 0 30px;
  &:hover {
    .title {
      color: @green!important;
    }
    background-color: rgba(185, 195, 195, 0.15);
  }
}
.wb-item {
  display: flex;
  padding: 30px 0;
  border-bottom: 1px solid #f5f5f5;
  position: relative;
  &:last-child {
    border: 0;
  }
  .warning {
    position: absolute;
    left: 0;
    top: 0;
  }
  .avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    .default {
      min-height: 50px;
      max-height: 50px;
    }
    .origin {
      width: 100%;
    }
  }
  .content {
    flex: 1;
    margin-left: 20px;
    margin-right: 90px;
    .top-wrap {
      display: flex;
      .title {
        height: 25px;
        line-height: 25px;
        font-size: 18px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #2d3236;
      }
      .include-media-type {
        display: flex;
        align-items: center;
        margin-left: 12px;
        img {
          margin-right: 12px;
        }
      }
    }
    .digest {
      margin: 10px 0;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #050f0f;
      line-height: 20px;
    }
    .medias {
      display: flex;
      .media {
        cursor: pointer;
        width: 70px;
        height: 70px;
        border-radius: 4px;
        margin-right: 8px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        position: relative;
        overflow: hidden;
        .verify-item {
          position: absolute;
          left: 0;
          top: 0;
          background-color: @green;
          width: 20px;
          height: 20px;
          border-radius: 0 0 100% 0;
          z-index: 1;
          line-height: 10px;
          &.verify-fail {
            background-color: #ff3e53;
          }
          img {
            padding: 2px;
          }
        }
        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
        &.default {
          width: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          .img {
            width: auto;
            min-height: 70px;
            max-height: 70px;
          }
        }
        .play {
          width: 50px;
          height: auto;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          margin: auto;
        }
      }
    }
    .info {
      display: flex;
      font-size: 13px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #b9c3c3;
      line-height: 18px;
      margin-top: 10px;
      .time {
        margin-right: 10px;
      }
    }
  }
  .push-wrap {
    display: flex;
    margin-top: 50px;
    .push-btn {
      cursor: pointer;
      font-size: 14px;
      // font-family: PingFang-SC-Bold, PingFang-SC;
      // font-weight: bold;
      color: #829191;
      width: 70px;
      line-height: 30px;
      text-align: center;
      height: 30px;
      box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
        .greenBtn;
      }
    }
    .greenBtn {
      background-color: @green !important;
      color: #fff !important;
    }
  }
}
</style>
